import PropTypes from "prop-types";
import React, { Component } from "react";
import { Trans } from "@lingui/macro";
import {
  addNewPerson,
  editListUsers,
  isPaymentRequired,
  subscribe
} from "../utils/fetcher";
import { connect } from "react-redux";
import {
  addFieldData,
  addUserSelected,
  removeStepChildren,
  removeUserSelected,
  setActiveStep,
  setMessage,
  setPayment,
  setSocialSecurity
} from "../actions";
import List from "@material-ui/core/List";
import Checkbox from "@material-ui/core/Checkbox";
import ListItemText from "@material-ui/core/ListItemText";
import AddPerson from "./AddPerson";
import { Button, Grid, Radio } from "@material-ui/core";
import { translator } from "../utils/i18n";
import { reset } from "redux-form";
import AlertDialog from "./AlertDialog";
import { goToBeginning } from "../utils/scenario-manager";
import PaymentPopin from "./PaymentPopin";
import SocialSecurityDialog from "./SocialSecurityDialog";

class ListPersons extends Component {
  originalActiveStep = {};
  alertContent =
    "<p class='secondary' style='font-size: larger'>" +
    translator()
      ._("W_PAYMENT")
      .toUpperCase() +
    "</p>" +
    translator()._("W_PAY_REDIRECT");
  state = {
    usersIdSelected: [],
    isShowDialogSecurity: false,
    currentPatientId: "",
    currentPatientInfo: null,
    alertPayment: false,
    showPayment: false,
    initLine: true
  };
  firstInit = true;

  componentDidMount() {
    this.props.step.data.fetchSource &&
      this.props.fetchData(this.props.step.data.fetchSource);
    this.originalActiveStep = { ...this.props.activeStep };
  }

  componentWillUnmount() {
    const dataKey = this.props.step.data.keyValue;
    this.props.resetData(dataKey);
  }

  getData = () => {
    const dataKey = this.props.step.data.keyValue;
    const { step } = this.props;
    const stepData = step.data;
    if (this.props.dataSource && this.props.dataSource[dataKey]) {
      let data = this.props.dataSource[dataKey];
      if (data && stepData.formatSource) {
        data = stepData.formatSource(data);
      }
      return data;
    }
    return null;
  };

  handleCloseAlert = () => {
    this.props.resetPayment();
  };

  handleToggleRadio = user => {
    if (this.props.usersSelected.length === 0) {
      this.addUserSelected(user);
    } else {
      this.addUserSelected(user);
      this.props.removeUserSelected(this.props.usersSelected[0]);
    }
  };

  addUserSelected = user => {
    const needAddr = this.props.infoForStatusFormField.b_activ_adresse;
    const needMT = this.props.infoForStatusFormField.b_activ_medecin_traitant;
    const needSC = this.props.isRequiredSocialSecurity;
    this.props.resetSocialSecurityFunc();
    const newState = {
      isShowDialogSecurity: needAddr || needMT || needSC,
      currentPatientId: user?.identifiant_user,
      currentPatientInfo: user
    };
    if (
      this.state.initLine &&
      this.props.nbPeople > 1 &&
      this.props.usersSelected.length + 1 >= this.props.nbPeople
    ) {
      newState["initLine"] = false;
    }
    this.setState(newState);
    if (!needAddr && !needMT && !needSC) {
      this.props.addUserSelected(user.identifiant_user);
    }
  };

  handleToggle = user => {
    const currentIndex = this.props.usersSelected.indexOf(
      user.identifiant_user
    );

    if (currentIndex === -1) {
      if (this.props.usersSelected.length >= parseInt(this.props.nbPeople)) {
        this.props.removeUserSelected(
          this.props.usersSelected[this.props.usersSelected.length - 1]
        );
      }
      this.addUserSelected(user);
    } else {
      this.props.removeUserSelected(user.identifiant_user);
      this.setState({
        currentPatientId: "",
        currentPatientInfo: null,
        isShowDialogSecurity: false
      });
    }
  };

  goToBeginning = () => {
    this.props.goToBeginning();
  };

  getRadioItem = (item, key) => {
    const labelId = `radio-list-label-${key}`;

    return (
      <div style={{ display: "flex" }}>
        <Radio
          checked={
            this.props.usersSelected.indexOf(item.identifiant_user) !== -1
          }
          inputProps={{ "aria-labelledby": labelId }}
          value={item.identifiant_user}
          name="radio-linkedAccount"
          onChange={() => this.handleToggleRadio(item)}
          color="primary"
        />
        <ListItemText
          style={{ textAlign: "left" }}
          id={`checkbox-list-text-${key}`}
          primary={` ${item.abreviation_civilite} ${item.nom_user} ${
            item.prenom_user
          } `}
          secondary={`(${item.parent_user})`}
        />
      </div>
    );
  };

  getCheckboxItem = (item, key) => {
    const labelId = `checkbox-list-label-${key}`;

    return (
      <div style={{ display: "flex" }}>
        <Checkbox
          checked={
            this.props.usersSelected.indexOf(item.identifiant_user) !== -1
          }
          color="primary"
          tabIndex={-1}
          inputProps={{ "aria-labelledby": labelId }}
          value={item.identifiant_user}
          onChange={() => this.handleToggle(item)}
          style={{ height: "fit-content" }}
        />
        <ListItemText
          style={{ textAlign: "left" }}
          id={`checkbox-list-text-${key}`}
          primary={` ${item.abreviation_civilite} ${item.nom_user} ${
            item.prenom_user
          } `}
          secondary={`(${item.parent_user})`}
        />
      </div>
    );
  };

  getRender = data => {
    if (data) {
      let listItems = data.map((item, key) => {
        const labelId = `radio-list-label-${key}`;
        return (
          <Grid item xs={6} key={labelId}>
            {this.props.nbPeople > 1
              ? this.getCheckboxItem(item, key)
              : this.getRadioItem(item, key)}
          </Grid>
        );
      });
      return (
        <Grid style={{ padding: "10px" }} container>
          {listItems}
        </Grid>
      );
    }
  };

  handleSubmitFormAddPerson = values => {
    this.props.addNewPerson(values);
    this.props.resetForm("addPerson");
  };

  getSelectedUsers = e => {
    e.preventDefault();
    if (this.props.usersSelected.length !== parseInt(this.props.nbPeople)) {
      this.props.setMessage(
        "Vous n'avez pas sélectionné suffisament de personnes"
      );
    } else {
      this.props.isPaymentRequiredFunc(this.props.usersSelected);
    }
  };

  handleAlertPayment = () => {
    this.setState({ showPayment: true });
  };

  closeDialog = () => {
    this.setState({
      isShowDialogSecurity: false,
      currentPatientId: "",
      currentPatientInfo: null
    });
  };

  handleAlertClose = () => {
    this.props.setMessage(null);
  };

  render() {
    const data = this.getData();
    const infoNewForm = this.props.infoForStatusFormField;
    const textAlert = `${translator()._("W_STEP4_BAS_LIST_ACTUELLEMENT")} 
      ${this.props.usersSelected.length} 
      ${
        this.props.usersSelected.length > 1
          ? translator()._("W_STEP4_BAS_LIST_PERSONNES")
          : translator()._("W_STEP4_BAS_LIST_PERSONNE")
      }
      / 
      ${this.props.nbPeople} 
      ${
        this.props.nbPeople > 1
          ? translator()._("W_STEP4_BAS_LIST_PARTICIPENTS_AU_RDV")
          : translator()._("W_STEP4_BAS_LIST_PARTICIPE_AU_RDV")
      }
    `;
    if (this.firstInit && this.props.usersSelected.length === 0 && data) {
      this.firstInit = false;
      this.addUserSelected(data[0]);
    }

    const showInformationLine =
      this.props.nbPeople > 1 &&
      this.props.usersSelected.length >= this.props.nbPeople;
    return (
      <React.Fragment>
        {this.state.isShowDialogSecurity && (
          <SocialSecurityDialog
            patientId={this.state.currentPatientId}
            currentPatientInfo={this.state.currentPatientInfo}
            infoNewForm={infoNewForm}
            closeDialog={this.closeDialog}
            isRequiredSocialSecurity={this.props.isRequiredSocialSecurity}
          />
        )}
        {this.props.message && !this.state.isShowDialogSecurity && (
          <AlertDialog
            content={this.props.message}
            onClick={this.handleAlertClose}
          />
        )}
        {this.props.payment &&
          this.props.payment.sum &&
          !this.state.isShowDialogSecurity &&
          this.props.payment.isRequired &&
          !this.state.showPayment && (
            <AlertDialog
              onClick={this.handleAlertPayment}
              content={this.alertContent}
              closeButton={true}
              handleClose={this.handleCloseAlert}
            />
          )}

        {this.state.showPayment && !this.state.isShowDialogSecurity && (
          <PaymentPopin open={true} />
        )}
        {!this.state.isShowDialogSecurity && (
          <>
            <div className="label mb-5">
              <img src="images/icone-professionnel.png" alt="" />
              {this.props.nbPeople > 1 ? (
                <Trans id="W_STEP4_TITRE_MENU_SELECTIONNEZ_LES_PERSONNES_CONCERNEES_PAR_VOTRE_RDV" />
              ) : (
                <Trans id="W_STEP4_TITRE_MENU_SELECTIONNEZ_LA_PERSONNE_CONCERNEE_PAR_VOTRE_RDV" />
              )}
            </div>
            <div className="mb-5 mt-20 text-s primary">
              <Trans id="W_INFO_RENDEZ_VOUS_USER" />
            </div>
          </>
        )}
        {data && !this.state.isShowDialogSecurity && (
          <div className="list-persons">
            <List className="wrap-list-persons">{this.getRender(data)}</List>
            {this.props.nbPeople > 1 && (
              <div
                className={
                  "informationBigLine mb-10 primary-bg " +
                  (showInformationLine
                    ? "animationFadeIn"
                    : this.state.initLine
                    ? ""
                    : "animationFadeOut")
                }
                style={{ opacity: this.state.initLine ? "0" : "1" }}
              >
                <Trans id="W_MESSAGE_ADD_PERSONNE" />
              </div>
            )}
            <AddPerson
              isRequiredSocialSecurity={this.props.isRequiredSocialSecurity}
              infoNewForm={infoNewForm}
              onSubmit={this.handleSubmitFormAddPerson}
            />
            {this.props.nbPeople > 1 && (
              <p className="text-info primary">
                <i className="material-icons">people</i>
                {textAlert}
              </p>
            )}
            <div className="align-right align-center-mobile bottom">
              <Button
                onClick={this.getSelectedUsers}
                className="btn-filled"
                color="primary"
                variant="contained"
              >
                <Trans id="W_VALIDER" />
              </Button>
            </div>
          </div>
        )}
      </React.Fragment>
    );
  }
}

ListPersons.propTypes = {
  activeStep: PropTypes.any,
  addNewPerson: PropTypes.func,
  addUserSelected: PropTypes.func,
  dataSource: PropTypes.any,
  fetchData: PropTypes.func,
  goToBeginning: PropTypes.func,
  infoForStatusFormField: PropTypes.shape({
    b_activ_adresse: PropTypes.any,
    b_activ_medecin_traitant: PropTypes.any
  }),
  isPaymentRequiredFunc: PropTypes.func,
  isRequiredSocialSecurity: PropTypes.any,
  message: PropTypes.any,
  nbPeople: PropTypes.number,
  payment: PropTypes.shape({
    isRequired: PropTypes.any,
    sum: PropTypes.any
  }),
  removeUserSelected: PropTypes.func,
  resetData: PropTypes.func,
  resetForm: PropTypes.func,
  resetPayment: PropTypes.func,
  resetSocialSecurityFunc: PropTypes.func,
  step: PropTypes.shape({
    data: PropTypes.shape({
      fetchSource: PropTypes.func,
      formatSource: PropTypes.func,
      keyValue: PropTypes.any
    })
  }),
  usersSelected: PropTypes.any,
  setMessage: PropTypes.func
};

const mapStateToProps = state => {
  return {
    dataSource: state.dataSource,
    nbPeople: state.returnedValue.nbPeople,
    message: state.message,
    activeStep: state.activeStep,
    usersSelected: state.usersSelected,
    payment: state.payment,
    isRequiredSocialSecurity: state.configuration.baffsecu,
    isRequiredPayment: state.payment && state.payment.isRequired,
    nbrSocialSecurity: state.socialSecurity,
    infoForStatusFormField: state.infoForStatusFormField,
    paymentDetails: state.paymentDetails
  };
};

const mapDispatchToProps = dispatch => ({
  inscription: values => dispatch(subscribe(values)),
  fetchData: functionName => dispatch(functionName()),
  resetData: key => dispatch(addFieldData(key, null)),
  addNewPerson: values => dispatch(addNewPerson(values)),
  editListUsers: idUsers => dispatch(editListUsers(idUsers)),
  resetForm: myForm => dispatch(reset(myForm)),
  setActiveStep: activeStep => dispatch(setActiveStep(activeStep)),
  removeStepChildren: activeStep => dispatch(removeStepChildren(activeStep)),
  goToBeginning: () => dispatch(goToBeginning()),
  addUserSelected: userId => dispatch(addUserSelected(userId)),
  removeUserSelected: userId => dispatch(removeUserSelected(userId)),
  isPaymentRequiredFunc: idUsers => dispatch(isPaymentRequired(idUsers)),
  resetSocialSecurityFunc: () => dispatch(setSocialSecurity(0)),
  resetPayment: () => dispatch(setPayment({})),
  setMessage: message => dispatch(setMessage(message))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ListPersons);
